import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/utils/cn'
import type { ChangeEntry } from '@/changelog'
import { MODULE_META, TYPE_META } from './meta'

export function ChangeEntryCard({ entry, unseen, compact, onNavigate }: {
  entry: ChangeEntry
  unseen?: boolean
  /** Panel variant: tighter spacing, body clamped to two lines. */
  compact?: boolean
  onNavigate?: () => void
}) {
  const type = TYPE_META[entry.type]
  const module = MODULE_META[entry.module]
  const ModuleIcon = module.icon
  return (
    <div className={cn(compact ? 'px-4 py-3' : 'p-4 bg-bg-elevated border border-border-default rounded-xl')}>
      <div className="flex items-center gap-2 mb-1.5">
        <span className={cn('text-[10px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded border', type.className)}>{type.label}</span>
        <span className="flex items-center gap-1 text-[11px] text-text-tertiary">
          <ModuleIcon className="w-3 h-3" /> {module.label}
        </span>
        {unseen && <span className="ml-auto w-1.5 h-1.5 rounded-full bg-brand-500 flex-shrink-0" aria-label="Unread" />}
      </div>
      <p className="text-sm font-medium text-text-primary">{entry.title}</p>
      <p className={cn('text-xs text-text-secondary mt-0.5 leading-relaxed', compact && 'line-clamp-2')}>{entry.body}</p>
      {entry.link && (
        <Link to={entry.link.to} onClick={onNavigate}
          className="inline-flex items-center gap-1 mt-2 text-xs font-medium text-brand-500 hover:text-brand-400">
          {entry.link.label} <ArrowRight className="w-3 h-3" />
        </Link>
      )}
    </div>
  )
}
